;(function() {
  'use strict'

  angular.module('app.core').factory('ProjectTracker', Factory)

  function Factory() {
    function ProjectTracker(options) {
      this.applyDefaults(options)
    }

    ProjectTracker.prototype.applyDefaults = function(options) {
      _.defaults(this, options, {
        id: null,
        projectId: null,
        name: null,
        fileData: null,
        fileName: null,
        imageUrl: null,
        createdAt: moment(),
        updatedAt: moment(),
      })
    }

    ProjectTracker.prototype.deserialize = function(data) {
      this.id = data.id
      this.projectId = data.projectId
      this.name = data.name
      this.fileName = data.fileName
      this.imageUrl = data.imageUrl
      this.createdAt = data.createdAt ? moment(data.createdAt) : null
      this.updatedAt = data.updatedAt ? moment(data.updatedAt) : null
      this.applyDefaults()
      return this
    }

    ProjectTracker.prototype.serialize = function() {
      var data = {}
      data.name = this.name
      if (this.fileData) {
        data.fileData = this.fileData
      }
      data.fileName = this.fileName
      data.imageUrl = this.imageUrl
      return data
    }

    ProjectTracker.prototype.isNew = function() {
      return !this.id
    }

    ProjectTracker.prototype.validate = function() {
      var errors = []
      if (!this.name) {
        errors.push('Name is required.')
      }
      if (this.isNew() && !this.fileData) {
        errors.push('Tracker HTML file is required.')
      }
      this.errors = errors
      return errors.length === 0
    }

    ProjectTracker.prototype.clone = function() {
      return new ProjectTracker().deserialize({
        id: this.id,
        projectId: this.projectId,
        name: this.name,
        fileName: this.fileName,
        imageUrl: this.imageUrl,
        createdAt: this.createdAt && this.createdAt.toISOString(),
        updatedAt: this.updatedAt && this.updatedAt.toISOString(),
      })
    }

    return ProjectTracker
  }
})()
